import { render } from "./Tag.vue?vue&type=template&id=f17a7094&scoped=true"
import script from "./Tag.vue?vue&type=script&lang=js"
export * from "./Tag.vue?vue&type=script&lang=js"

import "./Tag.vue?vue&type=style&index=0&id=f17a7094&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f17a7094"]])

export default __exports__